export class ColumnItemDto<TEnum> { // Didn't find a good way to enforce generic enum for TS
  ColumnName: TEnum;
}
